import { Box, Paper, Typography } from "@mui/material";
import { fData } from "../utils/numberFormat";
import { alpha } from "@mui/material/styles";

function RejectionFile({ fileRejections }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        borderColor: "error.light",
        bgColor: (theme) => alpha(theme.palette.error.main, 0.08),
      }}
    >
      {fileRejections.map((file, error) => {
        const { path, size } = file;
        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {fData(size)}
            </Typography>

            {error.map((error) => (
              <Typography key={error.code} variant="caption" component="p">
                - {error.message}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}

export default RejectionFile;
